
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("dAXoa"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("8rU16"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("kV1Ga"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("3mUar"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("8P67D"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("7T15o"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("9lfej"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("2mgpe"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fNaFL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("766Rf"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("fFsdU"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("8E6Fj"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("dAXoa", function(module, exports) {

let $9e5cb48503c5b79b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e5cb48503c5b79b$var$load("2YffH"),
    $9e5cb48503c5b79b$var$load("8Kivm"),
    $9e5cb48503c5b79b$var$load("2lBtX"),
    $9e5cb48503c5b79b$var$load("kBo7y"),
    $9e5cb48503c5b79b$var$load("iQ0Jm"),
    $9e5cb48503c5b79b$var$load("coJiW"),
    $9e5cb48503c5b79b$var$load("2vMNT"),
    $9e5cb48503c5b79b$var$load("ahI4T"),
    $9e5cb48503c5b79b$var$load("h4Nf7"),
    $9e5cb48503c5b79b$var$load("7f9Fz"),
    $9e5cb48503c5b79b$var$load("8YSo7"),
    $9e5cb48503c5b79b$var$load("lYvov"),
    $9e5cb48503c5b79b$var$load("k8XPW"),
    $9e5cb48503c5b79b$var$load("fWCRm"),
    $9e5cb48503c5b79b$var$load("g9CVe"),
    $9e5cb48503c5b79b$var$load("aeEUI"),
    $9e5cb48503c5b79b$var$load("hRUX7"),
    $9e5cb48503c5b79b$var$load("g4oYs"),
    $9e5cb48503c5b79b$var$load("6wr18"),
    $9e5cb48503c5b79b$var$load("kjZZD"),
    $9e5cb48503c5b79b$var$load("3ySTn"),
    $9e5cb48503c5b79b$var$load("c2rHL"),
    $9e5cb48503c5b79b$var$load("awqCy"),
    $9e5cb48503c5b79b$var$load("kHOMt"),
    $9e5cb48503c5b79b$var$load("hhss7"),
    $9e5cb48503c5b79b$var$load("6kZfp"),
    $9e5cb48503c5b79b$var$load("2UbDA"),
    $9e5cb48503c5b79b$var$load("nbjnv"),
    $9e5cb48503c5b79b$var$load("Wowvf"),
    $9e5cb48503c5b79b$var$load("ffEVr"),
    $9e5cb48503c5b79b$var$load("jlSv2"),
    $9e5cb48503c5b79b$var$load("1UUrt"),
    $9e5cb48503c5b79b$var$load("jSdjl"),
    $9e5cb48503c5b79b$var$load("l2EUC"),
    $9e5cb48503c5b79b$var$load("kWZnd"),
    $9e5cb48503c5b79b$var$load("92LGf"),
    $9e5cb48503c5b79b$var$load("let0D"),
    $9e5cb48503c5b79b$var$load("joFPh"),
    $9e5cb48503c5b79b$var$load("b7jBL"),
    $9e5cb48503c5b79b$var$load("kUbUu"),
    $9e5cb48503c5b79b$var$load("2PePB"),
    $9e5cb48503c5b79b$var$load("1W4KB"),
    $9e5cb48503c5b79b$var$load("lnKog"),
    $9e5cb48503c5b79b$var$load("9ftJe"),
    $9e5cb48503c5b79b$var$load("h3ABO"),
    $9e5cb48503c5b79b$var$load("kC80R"),
    $9e5cb48503c5b79b$var$load("7EorR"),
    $9e5cb48503c5b79b$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("8rU16", function(module, exports) {

let $626c4c1d1b3c0bef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $626c4c1d1b3c0bef$var$load("2YffH"),
    $626c4c1d1b3c0bef$var$load("8Kivm"),
    $626c4c1d1b3c0bef$var$load("2lBtX"),
    $626c4c1d1b3c0bef$var$load("kBo7y"),
    $626c4c1d1b3c0bef$var$load("iQ0Jm"),
    $626c4c1d1b3c0bef$var$load("coJiW"),
    $626c4c1d1b3c0bef$var$load("2vMNT"),
    $626c4c1d1b3c0bef$var$load("ahI4T"),
    $626c4c1d1b3c0bef$var$load("h4Nf7"),
    $626c4c1d1b3c0bef$var$load("7f9Fz"),
    $626c4c1d1b3c0bef$var$load("8YSo7"),
    $626c4c1d1b3c0bef$var$load("lYvov"),
    $626c4c1d1b3c0bef$var$load("k8XPW"),
    $626c4c1d1b3c0bef$var$load("fWCRm"),
    $626c4c1d1b3c0bef$var$load("g9CVe"),
    $626c4c1d1b3c0bef$var$load("aeEUI"),
    $626c4c1d1b3c0bef$var$load("hRUX7"),
    $626c4c1d1b3c0bef$var$load("g4oYs"),
    $626c4c1d1b3c0bef$var$load("6wr18"),
    $626c4c1d1b3c0bef$var$load("kjZZD"),
    $626c4c1d1b3c0bef$var$load("3ySTn"),
    $626c4c1d1b3c0bef$var$load("c2rHL"),
    $626c4c1d1b3c0bef$var$load("awqCy"),
    $626c4c1d1b3c0bef$var$load("kHOMt"),
    $626c4c1d1b3c0bef$var$load("hhss7"),
    $626c4c1d1b3c0bef$var$load("6kZfp"),
    $626c4c1d1b3c0bef$var$load("2UbDA"),
    $626c4c1d1b3c0bef$var$load("nbjnv"),
    $626c4c1d1b3c0bef$var$load("Wowvf"),
    $626c4c1d1b3c0bef$var$load("ffEVr"),
    $626c4c1d1b3c0bef$var$load("jlSv2"),
    $626c4c1d1b3c0bef$var$load("1UUrt"),
    $626c4c1d1b3c0bef$var$load("jSdjl"),
    $626c4c1d1b3c0bef$var$load("l2EUC"),
    $626c4c1d1b3c0bef$var$load("kWZnd"),
    $626c4c1d1b3c0bef$var$load("92LGf"),
    $626c4c1d1b3c0bef$var$load("let0D"),
    $626c4c1d1b3c0bef$var$load("joFPh"),
    $626c4c1d1b3c0bef$var$load("b7jBL"),
    $626c4c1d1b3c0bef$var$load("kUbUu"),
    $626c4c1d1b3c0bef$var$load("2PePB"),
    $626c4c1d1b3c0bef$var$load("1W4KB"),
    $626c4c1d1b3c0bef$var$load("lnKog"),
    $626c4c1d1b3c0bef$var$load("9ftJe"),
    $626c4c1d1b3c0bef$var$load("h3ABO"),
    $626c4c1d1b3c0bef$var$load("kC80R"),
    $626c4c1d1b3c0bef$var$load("7EorR"),
    $626c4c1d1b3c0bef$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("kV1Ga", function(module, exports) {

let $f3aa6ef483ebced7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3aa6ef483ebced7$var$load("2YffH"),
    $f3aa6ef483ebced7$var$load("8Kivm"),
    $f3aa6ef483ebced7$var$load("2lBtX"),
    $f3aa6ef483ebced7$var$load("kBo7y"),
    $f3aa6ef483ebced7$var$load("iQ0Jm"),
    $f3aa6ef483ebced7$var$load("coJiW"),
    $f3aa6ef483ebced7$var$load("2vMNT"),
    $f3aa6ef483ebced7$var$load("ahI4T"),
    $f3aa6ef483ebced7$var$load("h4Nf7"),
    $f3aa6ef483ebced7$var$load("7f9Fz"),
    $f3aa6ef483ebced7$var$load("8YSo7"),
    $f3aa6ef483ebced7$var$load("lYvov"),
    $f3aa6ef483ebced7$var$load("k8XPW"),
    $f3aa6ef483ebced7$var$load("fWCRm"),
    $f3aa6ef483ebced7$var$load("g9CVe"),
    $f3aa6ef483ebced7$var$load("aeEUI"),
    $f3aa6ef483ebced7$var$load("hRUX7"),
    $f3aa6ef483ebced7$var$load("g4oYs"),
    $f3aa6ef483ebced7$var$load("6wr18"),
    $f3aa6ef483ebced7$var$load("kjZZD"),
    $f3aa6ef483ebced7$var$load("3ySTn"),
    $f3aa6ef483ebced7$var$load("c2rHL"),
    $f3aa6ef483ebced7$var$load("awqCy"),
    $f3aa6ef483ebced7$var$load("kHOMt"),
    $f3aa6ef483ebced7$var$load("hhss7"),
    $f3aa6ef483ebced7$var$load("6kZfp"),
    $f3aa6ef483ebced7$var$load("2UbDA"),
    $f3aa6ef483ebced7$var$load("nbjnv"),
    $f3aa6ef483ebced7$var$load("Wowvf"),
    $f3aa6ef483ebced7$var$load("ffEVr"),
    $f3aa6ef483ebced7$var$load("jlSv2"),
    $f3aa6ef483ebced7$var$load("1UUrt"),
    $f3aa6ef483ebced7$var$load("jSdjl"),
    $f3aa6ef483ebced7$var$load("l2EUC"),
    $f3aa6ef483ebced7$var$load("kWZnd"),
    $f3aa6ef483ebced7$var$load("92LGf"),
    $f3aa6ef483ebced7$var$load("let0D"),
    $f3aa6ef483ebced7$var$load("joFPh"),
    $f3aa6ef483ebced7$var$load("b7jBL"),
    $f3aa6ef483ebced7$var$load("kUbUu"),
    $f3aa6ef483ebced7$var$load("2PePB"),
    $f3aa6ef483ebced7$var$load("1W4KB"),
    $f3aa6ef483ebced7$var$load("lnKog"),
    $f3aa6ef483ebced7$var$load("9ftJe"),
    $f3aa6ef483ebced7$var$load("h3ABO"),
    $f3aa6ef483ebced7$var$load("kC80R"),
    $f3aa6ef483ebced7$var$load("7EorR"),
    $f3aa6ef483ebced7$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("3mUar", function(module, exports) {

let $273efedd0ee8629f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $273efedd0ee8629f$var$load("k8XPW"),
    $273efedd0ee8629f$var$load("fWCRm"),
    $273efedd0ee8629f$var$load("2YffH"),
    $273efedd0ee8629f$var$load("2PePB"),
    $273efedd0ee8629f$var$load("2lBtX"),
    $273efedd0ee8629f$var$load("kBo7y"),
    $273efedd0ee8629f$var$load("2vMNT"),
    $273efedd0ee8629f$var$load("ahI4T"),
    $273efedd0ee8629f$var$load("h4Nf7"),
    $273efedd0ee8629f$var$load("7f9Fz"),
    $273efedd0ee8629f$var$load("8YSo7"),
    $273efedd0ee8629f$var$load("lYvov"),
    $273efedd0ee8629f$var$load("g9CVe"),
    $273efedd0ee8629f$var$load("aeEUI"),
    $273efedd0ee8629f$var$load("hRUX7"),
    $273efedd0ee8629f$var$load("g4oYs"),
    $273efedd0ee8629f$var$load("6wr18"),
    $273efedd0ee8629f$var$load("kjZZD"),
    $273efedd0ee8629f$var$load("3ySTn"),
    $273efedd0ee8629f$var$load("c2rHL"),
    $273efedd0ee8629f$var$load("awqCy"),
    $273efedd0ee8629f$var$load("kHOMt"),
    $273efedd0ee8629f$var$load("hhss7"),
    $273efedd0ee8629f$var$load("6kZfp"),
    $273efedd0ee8629f$var$load("2UbDA"),
    $273efedd0ee8629f$var$load("nbjnv"),
    $273efedd0ee8629f$var$load("Wowvf"),
    $273efedd0ee8629f$var$load("ffEVr"),
    $273efedd0ee8629f$var$load("jlSv2"),
    $273efedd0ee8629f$var$load("1UUrt"),
    $273efedd0ee8629f$var$load("jSdjl"),
    $273efedd0ee8629f$var$load("l2EUC"),
    $273efedd0ee8629f$var$load("kWZnd"),
    $273efedd0ee8629f$var$load("92LGf"),
    $273efedd0ee8629f$var$load("let0D"),
    $273efedd0ee8629f$var$load("joFPh"),
    $273efedd0ee8629f$var$load("b7jBL"),
    $273efedd0ee8629f$var$load("1W4KB"),
    $273efedd0ee8629f$var$load("kUbUu"),
    $273efedd0ee8629f$var$load("9ftJe"),
    $273efedd0ee8629f$var$load("h3ABO"),
    $273efedd0ee8629f$var$load("kC80R"),
    $273efedd0ee8629f$var$load("7EorR"),
    $273efedd0ee8629f$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("8P67D", function(module, exports) {

let $66c7d5e13420aded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66c7d5e13420aded$var$load("k8XPW"),
    $66c7d5e13420aded$var$load("fWCRm"),
    $66c7d5e13420aded$var$load("2YffH"),
    $66c7d5e13420aded$var$load("2PePB"),
    $66c7d5e13420aded$var$load("2lBtX"),
    $66c7d5e13420aded$var$load("kBo7y"),
    $66c7d5e13420aded$var$load("2vMNT"),
    $66c7d5e13420aded$var$load("ahI4T"),
    $66c7d5e13420aded$var$load("h4Nf7"),
    $66c7d5e13420aded$var$load("7f9Fz"),
    $66c7d5e13420aded$var$load("8YSo7"),
    $66c7d5e13420aded$var$load("lYvov"),
    $66c7d5e13420aded$var$load("g9CVe"),
    $66c7d5e13420aded$var$load("aeEUI"),
    $66c7d5e13420aded$var$load("hRUX7"),
    $66c7d5e13420aded$var$load("g4oYs"),
    $66c7d5e13420aded$var$load("6wr18"),
    $66c7d5e13420aded$var$load("kjZZD"),
    $66c7d5e13420aded$var$load("3ySTn"),
    $66c7d5e13420aded$var$load("c2rHL"),
    $66c7d5e13420aded$var$load("awqCy"),
    $66c7d5e13420aded$var$load("kHOMt"),
    $66c7d5e13420aded$var$load("hhss7"),
    $66c7d5e13420aded$var$load("6kZfp"),
    $66c7d5e13420aded$var$load("2UbDA"),
    $66c7d5e13420aded$var$load("nbjnv"),
    $66c7d5e13420aded$var$load("Wowvf"),
    $66c7d5e13420aded$var$load("ffEVr"),
    $66c7d5e13420aded$var$load("jlSv2"),
    $66c7d5e13420aded$var$load("1UUrt"),
    $66c7d5e13420aded$var$load("jSdjl"),
    $66c7d5e13420aded$var$load("l2EUC"),
    $66c7d5e13420aded$var$load("kWZnd"),
    $66c7d5e13420aded$var$load("92LGf"),
    $66c7d5e13420aded$var$load("let0D"),
    $66c7d5e13420aded$var$load("joFPh"),
    $66c7d5e13420aded$var$load("b7jBL"),
    $66c7d5e13420aded$var$load("1W4KB"),
    $66c7d5e13420aded$var$load("kUbUu"),
    $66c7d5e13420aded$var$load("9ftJe"),
    $66c7d5e13420aded$var$load("h3ABO"),
    $66c7d5e13420aded$var$load("kC80R"),
    $66c7d5e13420aded$var$load("7EorR"),
    $66c7d5e13420aded$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("7T15o", function(module, exports) {

let $5bde83201f14ae42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bde83201f14ae42$var$load("k8XPW"),
    $5bde83201f14ae42$var$load("fWCRm"),
    $5bde83201f14ae42$var$load("2YffH"),
    $5bde83201f14ae42$var$load("2PePB"),
    $5bde83201f14ae42$var$load("2lBtX"),
    $5bde83201f14ae42$var$load("kBo7y"),
    $5bde83201f14ae42$var$load("2vMNT"),
    $5bde83201f14ae42$var$load("ahI4T"),
    $5bde83201f14ae42$var$load("h4Nf7"),
    $5bde83201f14ae42$var$load("7f9Fz"),
    $5bde83201f14ae42$var$load("8YSo7"),
    $5bde83201f14ae42$var$load("lYvov"),
    $5bde83201f14ae42$var$load("g9CVe"),
    $5bde83201f14ae42$var$load("aeEUI"),
    $5bde83201f14ae42$var$load("hRUX7"),
    $5bde83201f14ae42$var$load("g4oYs"),
    $5bde83201f14ae42$var$load("6wr18"),
    $5bde83201f14ae42$var$load("kjZZD"),
    $5bde83201f14ae42$var$load("3ySTn"),
    $5bde83201f14ae42$var$load("c2rHL"),
    $5bde83201f14ae42$var$load("awqCy"),
    $5bde83201f14ae42$var$load("kHOMt"),
    $5bde83201f14ae42$var$load("hhss7"),
    $5bde83201f14ae42$var$load("6kZfp"),
    $5bde83201f14ae42$var$load("2UbDA"),
    $5bde83201f14ae42$var$load("nbjnv"),
    $5bde83201f14ae42$var$load("Wowvf"),
    $5bde83201f14ae42$var$load("ffEVr"),
    $5bde83201f14ae42$var$load("jlSv2"),
    $5bde83201f14ae42$var$load("1UUrt"),
    $5bde83201f14ae42$var$load("jSdjl"),
    $5bde83201f14ae42$var$load("l2EUC"),
    $5bde83201f14ae42$var$load("kWZnd"),
    $5bde83201f14ae42$var$load("92LGf"),
    $5bde83201f14ae42$var$load("let0D"),
    $5bde83201f14ae42$var$load("joFPh"),
    $5bde83201f14ae42$var$load("b7jBL"),
    $5bde83201f14ae42$var$load("1W4KB"),
    $5bde83201f14ae42$var$load("kUbUu"),
    $5bde83201f14ae42$var$load("9ftJe"),
    $5bde83201f14ae42$var$load("h3ABO"),
    $5bde83201f14ae42$var$load("kC80R"),
    $5bde83201f14ae42$var$load("7EorR"),
    $5bde83201f14ae42$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("9lfej", function(module, exports) {

let $6cd1e38b1c1d013d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6cd1e38b1c1d013d$var$load("k8XPW"),
    $6cd1e38b1c1d013d$var$load("fWCRm"),
    $6cd1e38b1c1d013d$var$load("2YffH"),
    $6cd1e38b1c1d013d$var$load("2lBtX"),
    $6cd1e38b1c1d013d$var$load("kBo7y"),
    $6cd1e38b1c1d013d$var$load("2vMNT"),
    $6cd1e38b1c1d013d$var$load("ahI4T"),
    $6cd1e38b1c1d013d$var$load("h4Nf7"),
    $6cd1e38b1c1d013d$var$load("7f9Fz"),
    $6cd1e38b1c1d013d$var$load("8YSo7"),
    $6cd1e38b1c1d013d$var$load("lYvov"),
    $6cd1e38b1c1d013d$var$load("g9CVe"),
    $6cd1e38b1c1d013d$var$load("aeEUI"),
    $6cd1e38b1c1d013d$var$load("hRUX7"),
    $6cd1e38b1c1d013d$var$load("g4oYs"),
    $6cd1e38b1c1d013d$var$load("6wr18"),
    $6cd1e38b1c1d013d$var$load("kjZZD"),
    $6cd1e38b1c1d013d$var$load("3ySTn"),
    $6cd1e38b1c1d013d$var$load("c2rHL"),
    $6cd1e38b1c1d013d$var$load("awqCy"),
    $6cd1e38b1c1d013d$var$load("kHOMt"),
    $6cd1e38b1c1d013d$var$load("hhss7"),
    $6cd1e38b1c1d013d$var$load("6kZfp"),
    $6cd1e38b1c1d013d$var$load("2UbDA"),
    $6cd1e38b1c1d013d$var$load("nbjnv"),
    $6cd1e38b1c1d013d$var$load("Wowvf"),
    $6cd1e38b1c1d013d$var$load("ffEVr"),
    $6cd1e38b1c1d013d$var$load("jlSv2"),
    $6cd1e38b1c1d013d$var$load("1UUrt"),
    $6cd1e38b1c1d013d$var$load("jSdjl"),
    $6cd1e38b1c1d013d$var$load("l2EUC"),
    $6cd1e38b1c1d013d$var$load("kWZnd"),
    $6cd1e38b1c1d013d$var$load("92LGf"),
    $6cd1e38b1c1d013d$var$load("let0D"),
    $6cd1e38b1c1d013d$var$load("joFPh"),
    $6cd1e38b1c1d013d$var$load("b7jBL"),
    $6cd1e38b1c1d013d$var$load("kUbUu"),
    $6cd1e38b1c1d013d$var$load("2PePB"),
    $6cd1e38b1c1d013d$var$load("1W4KB"),
    $6cd1e38b1c1d013d$var$load("lnKog"),
    $6cd1e38b1c1d013d$var$load("9ftJe"),
    $6cd1e38b1c1d013d$var$load("h3ABO"),
    $6cd1e38b1c1d013d$var$load("kC80R"),
    $6cd1e38b1c1d013d$var$load("7EorR"),
    $6cd1e38b1c1d013d$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("2mgpe", function(module, exports) {

let $1b7a5cbe6075116f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b7a5cbe6075116f$var$load("2YffH"),
    $1b7a5cbe6075116f$var$load("2lBtX"),
    $1b7a5cbe6075116f$var$load("kBo7y"),
    $1b7a5cbe6075116f$var$load("coJiW"),
    $1b7a5cbe6075116f$var$load("2vMNT"),
    $1b7a5cbe6075116f$var$load("ahI4T"),
    $1b7a5cbe6075116f$var$load("h4Nf7"),
    $1b7a5cbe6075116f$var$load("7f9Fz"),
    $1b7a5cbe6075116f$var$load("8YSo7"),
    $1b7a5cbe6075116f$var$load("lYvov"),
    $1b7a5cbe6075116f$var$load("k8XPW"),
    $1b7a5cbe6075116f$var$load("fWCRm"),
    $1b7a5cbe6075116f$var$load("g9CVe"),
    $1b7a5cbe6075116f$var$load("aeEUI"),
    $1b7a5cbe6075116f$var$load("hRUX7"),
    $1b7a5cbe6075116f$var$load("g4oYs"),
    $1b7a5cbe6075116f$var$load("6wr18"),
    $1b7a5cbe6075116f$var$load("kjZZD"),
    $1b7a5cbe6075116f$var$load("3ySTn"),
    $1b7a5cbe6075116f$var$load("c2rHL"),
    $1b7a5cbe6075116f$var$load("dTsOE"),
    $1b7a5cbe6075116f$var$load("awqCy"),
    $1b7a5cbe6075116f$var$load("kHOMt"),
    $1b7a5cbe6075116f$var$load("hhss7"),
    $1b7a5cbe6075116f$var$load("6kZfp"),
    $1b7a5cbe6075116f$var$load("2UbDA"),
    $1b7a5cbe6075116f$var$load("nbjnv"),
    $1b7a5cbe6075116f$var$load("Wowvf"),
    $1b7a5cbe6075116f$var$load("ffEVr"),
    $1b7a5cbe6075116f$var$load("jlSv2"),
    $1b7a5cbe6075116f$var$load("1UUrt"),
    $1b7a5cbe6075116f$var$load("jSdjl"),
    $1b7a5cbe6075116f$var$load("l2EUC"),
    $1b7a5cbe6075116f$var$load("kWZnd"),
    $1b7a5cbe6075116f$var$load("92LGf"),
    $1b7a5cbe6075116f$var$load("let0D"),
    $1b7a5cbe6075116f$var$load("joFPh"),
    $1b7a5cbe6075116f$var$load("b7jBL"),
    $1b7a5cbe6075116f$var$load("kUbUu"),
    $1b7a5cbe6075116f$var$load("2PePB"),
    $1b7a5cbe6075116f$var$load("1W4KB"),
    $1b7a5cbe6075116f$var$load("lnKog"),
    $1b7a5cbe6075116f$var$load("9ftJe"),
    $1b7a5cbe6075116f$var$load("h3ABO"),
    $1b7a5cbe6075116f$var$load("kC80R"),
    $1b7a5cbe6075116f$var$load("7EorR"),
    $1b7a5cbe6075116f$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fNaFL", function(module, exports) {

let $b7f3b5f6bbf09e60$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7f3b5f6bbf09e60$var$load("2YffH"),
    $b7f3b5f6bbf09e60$var$load("2lBtX"),
    $b7f3b5f6bbf09e60$var$load("kBo7y"),
    $b7f3b5f6bbf09e60$var$load("coJiW"),
    $b7f3b5f6bbf09e60$var$load("2vMNT"),
    $b7f3b5f6bbf09e60$var$load("ahI4T"),
    $b7f3b5f6bbf09e60$var$load("h4Nf7"),
    $b7f3b5f6bbf09e60$var$load("7f9Fz"),
    $b7f3b5f6bbf09e60$var$load("8YSo7"),
    $b7f3b5f6bbf09e60$var$load("lYvov"),
    $b7f3b5f6bbf09e60$var$load("k8XPW"),
    $b7f3b5f6bbf09e60$var$load("fWCRm"),
    $b7f3b5f6bbf09e60$var$load("g9CVe"),
    $b7f3b5f6bbf09e60$var$load("aeEUI"),
    $b7f3b5f6bbf09e60$var$load("hRUX7"),
    $b7f3b5f6bbf09e60$var$load("g4oYs"),
    $b7f3b5f6bbf09e60$var$load("6wr18"),
    $b7f3b5f6bbf09e60$var$load("kjZZD"),
    $b7f3b5f6bbf09e60$var$load("3ySTn"),
    $b7f3b5f6bbf09e60$var$load("c2rHL"),
    $b7f3b5f6bbf09e60$var$load("dTsOE"),
    $b7f3b5f6bbf09e60$var$load("awqCy"),
    $b7f3b5f6bbf09e60$var$load("kHOMt"),
    $b7f3b5f6bbf09e60$var$load("hhss7"),
    $b7f3b5f6bbf09e60$var$load("6kZfp"),
    $b7f3b5f6bbf09e60$var$load("2UbDA"),
    $b7f3b5f6bbf09e60$var$load("nbjnv"),
    $b7f3b5f6bbf09e60$var$load("Wowvf"),
    $b7f3b5f6bbf09e60$var$load("ffEVr"),
    $b7f3b5f6bbf09e60$var$load("jlSv2"),
    $b7f3b5f6bbf09e60$var$load("1UUrt"),
    $b7f3b5f6bbf09e60$var$load("jSdjl"),
    $b7f3b5f6bbf09e60$var$load("l2EUC"),
    $b7f3b5f6bbf09e60$var$load("kWZnd"),
    $b7f3b5f6bbf09e60$var$load("92LGf"),
    $b7f3b5f6bbf09e60$var$load("let0D"),
    $b7f3b5f6bbf09e60$var$load("joFPh"),
    $b7f3b5f6bbf09e60$var$load("b7jBL"),
    $b7f3b5f6bbf09e60$var$load("kUbUu"),
    $b7f3b5f6bbf09e60$var$load("2PePB"),
    $b7f3b5f6bbf09e60$var$load("1W4KB"),
    $b7f3b5f6bbf09e60$var$load("lnKog"),
    $b7f3b5f6bbf09e60$var$load("9ftJe"),
    $b7f3b5f6bbf09e60$var$load("h3ABO"),
    $b7f3b5f6bbf09e60$var$load("kC80R"),
    $b7f3b5f6bbf09e60$var$load("7EorR"),
    $b7f3b5f6bbf09e60$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("766Rf", function(module, exports) {

let $52ae69c8b1c0332c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52ae69c8b1c0332c$var$load("k8XPW"),
    $52ae69c8b1c0332c$var$load("fWCRm"),
    $52ae69c8b1c0332c$var$load("2YffH"),
    $52ae69c8b1c0332c$var$load("2PePB"),
    $52ae69c8b1c0332c$var$load("2lBtX"),
    $52ae69c8b1c0332c$var$load("kBo7y"),
    $52ae69c8b1c0332c$var$load("2vMNT"),
    $52ae69c8b1c0332c$var$load("ahI4T"),
    $52ae69c8b1c0332c$var$load("h4Nf7"),
    $52ae69c8b1c0332c$var$load("7f9Fz"),
    $52ae69c8b1c0332c$var$load("8YSo7"),
    $52ae69c8b1c0332c$var$load("lYvov"),
    $52ae69c8b1c0332c$var$load("g9CVe"),
    $52ae69c8b1c0332c$var$load("aeEUI"),
    $52ae69c8b1c0332c$var$load("hRUX7"),
    $52ae69c8b1c0332c$var$load("g4oYs"),
    $52ae69c8b1c0332c$var$load("6wr18"),
    $52ae69c8b1c0332c$var$load("kjZZD"),
    $52ae69c8b1c0332c$var$load("3ySTn"),
    $52ae69c8b1c0332c$var$load("c2rHL"),
    $52ae69c8b1c0332c$var$load("awqCy"),
    $52ae69c8b1c0332c$var$load("kHOMt"),
    $52ae69c8b1c0332c$var$load("hhss7"),
    $52ae69c8b1c0332c$var$load("6kZfp"),
    $52ae69c8b1c0332c$var$load("2UbDA"),
    $52ae69c8b1c0332c$var$load("nbjnv"),
    $52ae69c8b1c0332c$var$load("Wowvf"),
    $52ae69c8b1c0332c$var$load("ffEVr"),
    $52ae69c8b1c0332c$var$load("jlSv2"),
    $52ae69c8b1c0332c$var$load("1UUrt"),
    $52ae69c8b1c0332c$var$load("jSdjl"),
    $52ae69c8b1c0332c$var$load("l2EUC"),
    $52ae69c8b1c0332c$var$load("kWZnd"),
    $52ae69c8b1c0332c$var$load("92LGf"),
    $52ae69c8b1c0332c$var$load("let0D"),
    $52ae69c8b1c0332c$var$load("joFPh"),
    $52ae69c8b1c0332c$var$load("b7jBL"),
    $52ae69c8b1c0332c$var$load("1W4KB"),
    $52ae69c8b1c0332c$var$load("kUbUu"),
    $52ae69c8b1c0332c$var$load("9ftJe"),
    $52ae69c8b1c0332c$var$load("h3ABO"),
    $52ae69c8b1c0332c$var$load("kC80R"),
    $52ae69c8b1c0332c$var$load("7EorR"),
    $52ae69c8b1c0332c$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("fFsdU", function(module, exports) {

let $b68093e67a03a194$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b68093e67a03a194$var$load("k8XPW"),
    $b68093e67a03a194$var$load("fWCRm"),
    $b68093e67a03a194$var$load("2YffH"),
    $b68093e67a03a194$var$load("2lBtX"),
    $b68093e67a03a194$var$load("kBo7y"),
    $b68093e67a03a194$var$load("2vMNT"),
    $b68093e67a03a194$var$load("ahI4T"),
    $b68093e67a03a194$var$load("h4Nf7"),
    $b68093e67a03a194$var$load("7f9Fz"),
    $b68093e67a03a194$var$load("8YSo7"),
    $b68093e67a03a194$var$load("lYvov"),
    $b68093e67a03a194$var$load("g9CVe"),
    $b68093e67a03a194$var$load("aeEUI"),
    $b68093e67a03a194$var$load("hRUX7"),
    $b68093e67a03a194$var$load("g4oYs"),
    $b68093e67a03a194$var$load("6wr18"),
    $b68093e67a03a194$var$load("kjZZD"),
    $b68093e67a03a194$var$load("3ySTn"),
    $b68093e67a03a194$var$load("c2rHL"),
    $b68093e67a03a194$var$load("awqCy"),
    $b68093e67a03a194$var$load("kHOMt"),
    $b68093e67a03a194$var$load("hhss7"),
    $b68093e67a03a194$var$load("6kZfp"),
    $b68093e67a03a194$var$load("2UbDA"),
    $b68093e67a03a194$var$load("nbjnv"),
    $b68093e67a03a194$var$load("Wowvf"),
    $b68093e67a03a194$var$load("ffEVr"),
    $b68093e67a03a194$var$load("jlSv2"),
    $b68093e67a03a194$var$load("1UUrt"),
    $b68093e67a03a194$var$load("jSdjl"),
    $b68093e67a03a194$var$load("l2EUC"),
    $b68093e67a03a194$var$load("kWZnd"),
    $b68093e67a03a194$var$load("92LGf"),
    $b68093e67a03a194$var$load("let0D"),
    $b68093e67a03a194$var$load("joFPh"),
    $b68093e67a03a194$var$load("b7jBL"),
    $b68093e67a03a194$var$load("kUbUu"),
    $b68093e67a03a194$var$load("2PePB"),
    $b68093e67a03a194$var$load("1W4KB"),
    $b68093e67a03a194$var$load("lnKog"),
    $b68093e67a03a194$var$load("9ftJe"),
    $b68093e67a03a194$var$load("h3ABO"),
    $b68093e67a03a194$var$load("kC80R"),
    $b68093e67a03a194$var$load("7EorR"),
    $b68093e67a03a194$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("8E6Fj", function(module, exports) {

let $64b73ac4a7afc55c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64b73ac4a7afc55c$var$load("k8XPW"),
    $64b73ac4a7afc55c$var$load("fWCRm"),
    $64b73ac4a7afc55c$var$load("2YffH"),
    $64b73ac4a7afc55c$var$load("2lBtX"),
    $64b73ac4a7afc55c$var$load("kBo7y"),
    $64b73ac4a7afc55c$var$load("2vMNT"),
    $64b73ac4a7afc55c$var$load("ahI4T"),
    $64b73ac4a7afc55c$var$load("h4Nf7"),
    $64b73ac4a7afc55c$var$load("7f9Fz"),
    $64b73ac4a7afc55c$var$load("8YSo7"),
    $64b73ac4a7afc55c$var$load("lYvov"),
    $64b73ac4a7afc55c$var$load("g9CVe"),
    $64b73ac4a7afc55c$var$load("aeEUI"),
    $64b73ac4a7afc55c$var$load("hRUX7"),
    $64b73ac4a7afc55c$var$load("g4oYs"),
    $64b73ac4a7afc55c$var$load("6wr18"),
    $64b73ac4a7afc55c$var$load("kjZZD"),
    $64b73ac4a7afc55c$var$load("3ySTn"),
    $64b73ac4a7afc55c$var$load("c2rHL"),
    $64b73ac4a7afc55c$var$load("awqCy"),
    $64b73ac4a7afc55c$var$load("kHOMt"),
    $64b73ac4a7afc55c$var$load("hhss7"),
    $64b73ac4a7afc55c$var$load("6kZfp"),
    $64b73ac4a7afc55c$var$load("2UbDA"),
    $64b73ac4a7afc55c$var$load("nbjnv"),
    $64b73ac4a7afc55c$var$load("Wowvf"),
    $64b73ac4a7afc55c$var$load("ffEVr"),
    $64b73ac4a7afc55c$var$load("jlSv2"),
    $64b73ac4a7afc55c$var$load("1UUrt"),
    $64b73ac4a7afc55c$var$load("jSdjl"),
    $64b73ac4a7afc55c$var$load("l2EUC"),
    $64b73ac4a7afc55c$var$load("kWZnd"),
    $64b73ac4a7afc55c$var$load("92LGf"),
    $64b73ac4a7afc55c$var$load("let0D"),
    $64b73ac4a7afc55c$var$load("joFPh"),
    $64b73ac4a7afc55c$var$load("b7jBL"),
    $64b73ac4a7afc55c$var$load("kUbUu"),
    $64b73ac4a7afc55c$var$load("2PePB"),
    $64b73ac4a7afc55c$var$load("1W4KB"),
    $64b73ac4a7afc55c$var$load("lnKog"),
    $64b73ac4a7afc55c$var$load("9ftJe"),
    $64b73ac4a7afc55c$var$load("h3ABO"),
    $64b73ac4a7afc55c$var$load("kC80R"),
    $64b73ac4a7afc55c$var$load("7EorR"),
    $64b73ac4a7afc55c$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.3f682f45.js.map
